export default "__VITE_PUBLIC_ASSET__bdcc1028__"